import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography, Popover } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { creditReviewLevelTypes } from 'shared/constants/creditReview/creditReviewLevelTypes';

const useStyles = makeStyles(theme => ({
  value: {
    cursor: 'default',
  },
  popover: {
    pointerEvents: 'none',
  },
  content: {
    padding: theme.spacing(1),
  },
  level: {
    minWidth: 50,
    padding: 5,
    margin: '5px 0',
    textAlign: 'center',
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.custom.white,
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.custom.white,
      color: theme.palette.text.primary,
    },
  },
  active: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.custom.white} !important`,
  },
}));

const CreditReviewLevelsPopover = ({ levelType, activeLevel }) => {
  const allLevels = useSelector(({ shared }) => shared.creditReviewLevels.data);

  const classes = useStyles();

  const wrapperRef = useRef(null);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [levels, setLevels] = useState([]);

  useEffect(() => {
    setLevels([...allLevels[levelType]].reverse().map(item => item.toUpperCase()));
  }, [levelType, allLevels]);

  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  if (!levels.length) {
    return activeLevel;
  }

  return (
    <div ref={wrapperRef}>
      <Typography
        className={classes.value}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {activeLevel}
      </Typography>
      <Popover
        className={classes.popover}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        container={wrapperRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className={classes.content}>
          {levels.map(level => (
            <div
              key={level}
              className={clsx(classes.level, {
                [classes.active]: level === activeLevel,
              })}
            >
              {level}
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
};

CreditReviewLevelsPopover.defaultProps = {
  activeLevel: '-',
};

CreditReviewLevelsPopover.propTypes = {
  activeLevel: PropTypes.string,
  levelType: PropTypes.oneOf(Object.values(creditReviewLevelTypes)).isRequired,
};

export default CreditReviewLevelsPopover;
